/**
 * Graphics inspection option types shared by both apps.
 *
 * Original locations: (identical values, verified):
 *  - web: apps/web/src/types/inspection.ts (GraphicsOptionKey, GraphicsSensitivity, MatchingMode)
 *  - api: apps/api/src/inspection/types/inspection.types.ts (GraphicsOptionKey, GraphicsSensitivity, MatchingMode)
 */
/** Keys used to persist graphics matching options. */
export var GraphicsOptionKey;
(function (GraphicsOptionKey) {
    GraphicsOptionKey["Sensitivity"] = "sensitivity";
    GraphicsOptionKey["MatchingMode"] = "matchingMode";
})(GraphicsOptionKey || (GraphicsOptionKey = {}));
/** Graphics comparison sensitivity level. */
export var GraphicsSensitivity;
(function (GraphicsSensitivity) {
    GraphicsSensitivity["HIGH"] = "High";
    GraphicsSensitivity["STANDARD"] = "Standard";
})(GraphicsSensitivity || (GraphicsSensitivity = {}));
/** How source graphics are matched against target graphics. */
export var MatchingMode;
(function (MatchingMode) {
    MatchingMode["OneToOne"] = "OneToOne";
    MatchingMode["OneToMany"] = "OneToMany";
})(MatchingMode || (MatchingMode = {}));
//# sourceMappingURL=graphics.js.map